module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cars-list"
  }, [_vm._l((_vm.carsRows), function(row) {
    return _vm._l((row.childArr), function(item) {
      return _c('div', {
        staticClass: "car-item-container"
      }, [_c('a', {
        attrs: {
          "href": item.href
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.goDetail(item)
          }
        }
      }, [_c("CarItem", {
        tag: "div",
        staticClass: "car-item",
        class: ['line-height-level-' + row.lineHeightLevel],
        attrs: {
          "data": item
        }
      })])])
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a12f0b1a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components-buy/ListContain/ListMain/CardBox.vue
// module id = 875
// module chunks = 5